module.exports = __webpack_public_path__ + "static/media/margee-quote-resized.e8af4678.jpg";